export const convertValueToNumberString = (value, precision = 0) => {
  return Number(value).toFixed(precision)
}
